import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/attendance-management-system/comprehensive-reporting/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "comprehensive-reporting" entry is kept); the seo block below is a fallback.

export const comprehensiveReporting: ContentPage = {
  slug: "attendance-management-system/comprehensive-reporting",
  template: "hrmsFeature",
  seo: {
    title: "In-depth Reporting for Enhanced Workforce Management",
    description: "Access detailed attendance analytics, customize reports, and export data with our reporting tools, streamlining operations and improving decision-making.",
    keywords: [
      "attendance reporting",
      "workforce analytics",
      "custom reports",
      "attendance data",
      "employee productivity analysis.",
    ],
    ogImage: "/assets/data/seoimages/comprehensive-reporting.webp",
  },
  leaf: {
    hero: {
      caption: "Comprehensive Reporting",
      title: "Gain Insights with Comprehensive Reporting",
      description: "Access detailed attendance reports to make informed decisions about labor costs, employee productivity, and shift planning.",
      h1: "caption",
    },
    split: {
      title: "Detailed Analytics for Better Decision Making",
      bullets: [
        { title: "Attendance Analytics", description: "View detailed reports on attendance trends and patterns." },
        { title: "Custom Report Builder", description: "Tailor reports to meet specific organizational needs." },
        { title: "Export Capabilities", description: "Share and export reports in various formats for easy integration." },
        { title: "Audit Preparation", description: "Prepare comprehensive reports for audits and compliance checks." },
      ],
      image: "/assets/images/img/product/hrms/attendancems/comprehensive-reporting.webp",
      imageAlt: "comprehensive-reporting",
    },
    cardsHeading: {
      title: "Key Features of Attendance Management System",
      description: "Optimize Attendance management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Shift Management",
        href: "/hrms-software/attendance-management-system/shift-management",
        description: "Manage and automate employee shifts efficiently to ensure coverage and reduce scheduling conflicts with our advanced shift management tools.",
        image: "/assets/images/img/product/hrms/attendancems/shift_management_key_features.webp",
        imageAlt: "shift_management_key_features",
      },
      {
        title: "Real-Time Attendance Tracking",
        href: "/hrms-software/attendance-management-system/real-time-attendance-tracking",
        description: "Capture accurate employee attendance data in real-time, streamlining payroll processes and enhancing workforce management.",
        image: "/assets/images/img/product/hrms/attendancems/real_time-attendance_tracking_key_features.webp",
        imageAlt: "real_time-attendance_tracking_key_features",
      },
      {
        title: "Overtime Monitoring",
        href: "/hrms-software/attendance-management-system/overtime-monitoring",
        description: "Ensure fair compensation and compliance with our sophisticated overtime monitoring system, reducing discrepancies and boosting morale.",
        image: "/assets/images/img/product/hrms/attendancems/overtime-monitoring_key_features.webp",
        imageAlt: "overtime-monitoring_key_features",
      },
      {
        title: "Geofencing Attendance",
        href: "/hrms-software/attendance-management-system/geofencing-attendance",
        description: "Utilize geofencing technology to manage employee attendance more securely and accurately, ideal for remote or on-site tracking.",
        image: "/assets/images/img/product/hrms/attendancems/geofencing_attendance_key_features.webp",
        imageAlt: "geofencing_attendance_key_features",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Unlock Powerful Insights with Advanced Reporting!",
    relatedBlogsKeyword: "hrms-comprehensive-reporting,hrms-attendance-management-dashboard",
    metaKey: "comprehensive-reporting",
  },
  sections: [],
};
